import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import JoinPage from "@/pages/JoinPage";
import PlayerPage from "@/pages/PlayerPage";
import AdminPage from "@/pages/AdminPage";
import RevealPage from "@/pages/RevealPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<JoinPage />} />
          <Route path="/play" element={<PlayerPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/reveal" element={<RevealPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "rgba(20, 10, 10, 0.95)",
            color: "#FFD700",
            border: "1px solid rgba(255, 215, 0, 0.3)",
          },
        }}
      />
    </div>
  );
}

export default App;
